(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/objectSpread", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/objectSpread"), require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.objectSpread, global.react);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _objectSpread2, _react) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.formatValue = formatValue;
  _exports.formatArray = formatArray;
  _exports.formatBoolValue = formatBoolValue;
  _exports.getValueProps = getValueProps;
  _exports.formatDate = formatDate;
  _exports.log = log;
  _exports.getCleanProps = getCleanProps;
  _exports.formatNumber = formatNumber;
  _exports.insetify = _exports.renderOption = _exports.renderValue = void 0;
  _objectSpread2 = _interopRequireDefault(_objectSpread2);
  _react = _interopRequireDefault(_react);

  var noop = function noop(v) {
    return v;
  };

  var isEmpty = function isEmpty(value) {
    return [undefined, null].indexOf(value) !== -1;
  };

  var renderValue = function renderValue(value) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var hasDefaultValue = 'defaultValue' in opts;
    var defaultEmptyValue = hasDefaultValue ? opts.defaultValue : null;
    if (isEmpty(value)) return defaultEmptyValue; // 空值直接返回

    if (Array.isArray(value)) {
      // 数组需要判断版本号返回
      var arrValue = value.map(function (valItem, idx) {
        return _react.default.createElement("span", {
          key: "".concat(valItem).concat(idx),
          className: "multi-value-item"
        }, valItem);
      });
      return _react.default.createElement("span", {
        className: "multi-value-item-wrapper"
      }, arrValue);
    }

    return _react.default.createElement("span", {
      className: "multi-value-item"
    }, value);
  };

  _exports.renderValue = renderValue;

  var renderOption = function renderOption() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // 处理

    var value = formatValue(props.value); // 格式化值

    var arrValue = [].concat(value); // 处理多选, 如checkbox

    if (Array.isArray(props.dataSource) || Array.isArray(props.options)) {
      // dataSource模式
      var dataSource = props.dataSource || props.options;
      var hitLabel = [];
      dataSource.forEach(function (item) {
        if (arrValue.indexOf(item.value) !== -1) {
          hitLabel.push(item.label);
        }
      });
      return renderValue(hitLabel);
    } else if (Array.isArray(props.children)) {
      // children模式
      var _hitLabel = [];
      props.children.forEach(function (item) {
        if (item.props && item.props.children && arrValue.indexOf(item.props.value) !== -1) {
          _hitLabel.push(item.props.children);
        }
      });
      return renderValue(_hitLabel);
    }

    return null;
  };

  _exports.renderOption = renderOption;

  var insetify = function insetify(props) {
    var insetProps = {};

    var _ref = props || {},
        className = _ref.className,
        inset = _ref.inset;

    if (inset) insetProps.className = "".concat(className || '', " inset-component");
    return insetProps;
  };

  _exports.insetify = insetify;

  function getCleanProps(props) {
    var otherProps = (0, _objectSpread2.default)({}, props);
    delete otherProps.status;
    delete otherProps.value;
    delete otherProps.inset;
    delete otherProps.error;
    return otherProps;
  }

  function getValueProps(props) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var valueProps = {};
    var _opts$keyname = opts.keyname,
        keyname = _opts$keyname === void 0 ? 'value' : _opts$keyname,
        _opts$format = opts.format,
        format = _opts$format === void 0 ? noop : _opts$format;
    var defaultValue = 'defaultValue' in opts ? defaultValue : '';

    if ('value' in props) {
      var propVal = props.value;

      if ([null, undefined].indexOf(propVal) !== -1) {
        valueProps[keyname] = format(defaultValue);
      } else {
        valueProps[keyname] = format(propVal);
      }
    }

    return valueProps;
  }

  function formatValue(value) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var hasDefaultValue = 'defaultValue' in opts;
    var defaultEmptyValue = hasDefaultValue ? opts.defaultValue : null;
    if (isEmpty(value)) return defaultEmptyValue;
    return value; // 0 或 []直接返回
  }

  function formatArray(value) {
    if (isEmpty(value)) return [];
    return value;
  }

  function formatBoolValue(value) {
    if (isEmpty(value)) return undefined;

    if ("".concat(value) === 'true') {
      return true;
    } else if ("".concat(value) === 'false') {
      return false;
    }

    return false;
  }

  function formatDate(value) {
    if (isEmpty(value)) return undefined;

    if (Next && Next.moment) {
      return Next.moment(value).format('YYYY-MM-DD');
    }

    return value;
  }

  function log() {}

  function formatNumber(value) {
    if (isEmpty(value)) return undefined;
    if (['0', 0, ''].indexOf(value) !== -1) return 0;
    return Number(value);
  }
});